import React from 'react';
import { Building2, Globe, GraduationCap, Users, MapPin } from 'lucide-react';
import { Section, Card } from '../hospital/shared/primitives';
import { LinkRow, IntroRow } from '../shared/ListRows';

const ACCENT = '#0369a1';

const BCMAnesthesiologyOverview = () => (
  <div className="space-y-6">
    <Card>
      <IntroRow icon={Building2} title="Department of Anesthesiology" accent={ACCENT}>
        Training across six institutions in the Texas Medical Center: Ben Taub, Baylor St. Luke's, the Texas Heart Institute, Texas Children's, the DeBakey VA and MD Anderson.
      </IntroRow>
    </Card>

    <Section title="At a glance">
      <Card>
        <LinkRow icon={GraduationCap} title="Four-year residency" subtitle="Clinical base year through CA-3, with subspecialty rotations at every site" accent={ACCENT} />
        <LinkRow icon={Users} title="Four fellowships" subtitle="Cardiac, pediatric, critical care and obstetric anesthesiology" accent={ACCENT} />
        <LinkRow icon={MapPin} title="Six training sites" subtitle="Each with its own rotation page in this app" accent={ACCENT} />
      </Card>
    </Section>

    <Section title="Links">
      <Card>
        <LinkRow icon={Globe} title="Department website" subtitle="bcm.edu/departments/anesthesiology" href="https://www.bcm.edu/departments/anesthesiology" accent={ACCENT} />
      </Card>
    </Section>
  </div>
);

export default BCMAnesthesiologyOverview;
